import { useCallback } from "react";
import { useMutation, gql } from "@apollo/client";

const TRACK_EVENT = gql`
  mutation TrackEvent($name: String!, $properties: JSON) {
    trackEvent(name: $name, properties: $properties)
  }
`;

/**
 * Client-side product-analytics events. Only UI-only signals are logged here
 * (session_started, feature_used, pricing_viewed, upgrade_clicked). The
 * high-value activation/value events are logged server-side in resolvers,
 * where delivery is reliable. The backend whitelists which names are accepted.
 *
 * Fire-and-forget: never awaited in the UI path, errors are swallowed.
 */
export function useTrackEvent() {
  const [mutate] = useMutation(TRACK_EVENT);

  return useCallback(
    (name: string, properties?: Record<string, unknown>) => {
      mutate({ variables: { name, properties: properties ?? {} } }).catch(() => {
        /* analytics must never break the UI */
      });
    },
    [mutate]
  );
}
